import React from 'react';
import AuthWithOTPButton from './AuthWithOTPButton';
import { IUser } from '@/models/User';

type AuthMethod = 'otp' | 'tiktok' | 'tiktokSignIn';

interface AuthProps {
  collectionAddress?: string | null;
  affiliateId?: string | null;
  role?: string;
  onLoginSuccess?: (user?: IUser) => void;
  welcomeText?: string;
  welcomeDescription?: string;
  verificationText?: string;
  linkTikTokTitle?: string;
  linkTikTokDescription?: string;
  signInWithTikTok?: boolean;
  signInTitle?: string;
  signInDescription?: string;
  authMethod?: AuthMethod;
}

const Auth: React.FC<AuthProps> = ({
  collectionAddress,
  affiliateId,
  role,
  onLoginSuccess,
  welcomeText,
  welcomeDescription,
  verificationText,
}) => {
  const handleLoginSuccess = (user?: IUser) => {
    if (onLoginSuccess) {
      onLoginSuccess(user);
    }
  };

  return (
    <>
      <AuthWithOTPButton
        collectionAddress={collectionAddress}
        affiliateId={affiliateId}
        role={role}
        onLoginSuccess={handleLoginSuccess}
        welcomeText={welcomeText}
        welcomeDescription={welcomeDescription}
        verificationText={verificationText}
      />
    </>
  );
};

export default Auth;
